export const AppleIcon = ({ className = "w-7 h-7" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

export const PlayIcon = ({ className = "w-7 h-7" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
    <path d="M3.6 1.8 13.8 12 3.6 22.2a1 1 0 0 1-.6-.92V2.73a1 1 0 0 1 .6-.93zm1.5-.37 11.2 6.17-2.87 1.6L5.1 1.43zm0 21.14 8.33-7.77 2.87 1.6-11.2 6.17zM20.4 11.16c.39.22.6.54.6.86s-.21.64-.6.86L17.5 14.4l-2.6-2.4 2.6-2.4 2.9 1.56z" />
  </svg>
);

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const DiceIcon = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden>
    <g {...stroke}>
      <rect x="5" y="5" width="22" height="22" rx="6" />
      <circle cx="12" cy="12" r="1.6" />
      <circle cx="20" cy="20" r="1.6" />
      <circle cx="16" cy="16" r="1.6" />
    </g>
  </svg>
);

export const KitIcon = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden>
    <g {...stroke}>
      <rect x="4" y="11" width="24" height="16" rx="4" />
      <path d="M12 11V8a4 4 0 0 1 8 0v3" />
      <path d="M4 18h24" />
      <path d="M14 16v4h4v-4z" />
    </g>
  </svg>
);

export const FlameIcon = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden>
    <g {...stroke}>
      <path d="M16 3c4 5 8 7.5 8 13a8 8 0 0 1-16 0c0-3 1.5-5 3-6.5.5 2 1.5 3 3 3.5-1-4 1-7.5 2-10z" />
      <path d="M16 27a4 4 0 0 1-4-4c0-2 2-3.2 4-6 2 2.8 4 4 4 6a4 4 0 0 1-4 4z" />
    </g>
  </svg>
);

export const PathIcon = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden>
    <g {...stroke}>
      <path d="M7 26c0-6 6-4 6-9s-6-3-6-9" />
      <circle cx="7" cy="8" r="2.5" />
      <circle cx="25" cy="24" r="2.5" />
      <path d="M13 17h6c2 0 3 1.5 3 3.5V21" />
    </g>
  </svg>
);

export const HomeIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <g {...stroke}>
      <path d="M4 11 12 4l8 7v8a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z" />
    </g>
  </svg>
);

export const BodyIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <g {...stroke}>
      <circle cx="12" cy="5" r="2.2" />
      <path d="M12 7.5V14m0 0-3.5 6M12 14l3.5 6M6 10l6-1.5 6 1.5" />
    </g>
  </svg>
);

export const TargetIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <g {...stroke}>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="3.5" />
      <path d="M12 2v3m0 14v3M2 12h3m14 0h3" />
    </g>
  </svg>
);

export const ClockIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <g {...stroke}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </g>
  </svg>
);

export const ICONS = {
  dice: DiceIcon,
  kit: KitIcon,
  flame: FlameIcon,
  path: PathIcon,
  home: HomeIcon,
  body: BodyIcon,
  target: TargetIcon,
  clock: ClockIcon,
};
